import { SplitFactory } from '@splitsoftware/splitio'
import { combineEpics, ofType } from 'redux-observable'
import { first, pluck } from 'rxjs/operators'

import config from 'config'
import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import store from 'modules/store'
import * as UserActions from 'modules/user/actions'
import { logImpression } from 'utils/experiments'

import * as actions from './actions'

export let client

const enrollUserInExperiment = (action$, state$) => {
  return action$.pipe(
    ofType(
      OrgActions.createOrgSuccess.toString(),
      UserActions.fetchUserSuccess.toString()
    ),
    pluck('payload'),
    first(() => {
      const orgId = OrgSelectors.getOrgId(state$.value)
      store.dispatch(actions.setPending())
      const factory = SplitFactory({
        core: {
          authorizationKey: config.SPLIT_ID,
          key: orgId,
          trafficType: 'organization',
        },
        impressionListener: {
          logImpression,
        },
      })
      client = factory.client()
      client.on(client.Event.SDK_READY, () => {
        store.dispatch(actions.setLoaded())
      })
      client.on(client.Event.SDK_READY_TIMED_OUT, () => {
        store.dispatch(actions.timedOut())
      })
    })
  )
}

export const epic = combineEpics(enrollUserInExperiment)
